import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { KeyTextObj } from '~src/interfaces/translation.interface';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

const EmptyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const EmptyMessageTxt = styled.span`
  font-size: 21px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  max-width: 20rem;
  margin-bottom: 2rem;
`;

const StyledLink = styled(Link)`
  width: 100%;
  max-width: 360px;
  display: flex;
  justify-content: center;
`;

interface Props {
  message: KeyTextObj;
  buttonMessage?: KeyTextObj;
  link?: string;
  marginTop?: number;
}

const EmptyListMessage: React.FC<Props> = ({ message, buttonMessage, link, marginTop = 60 }) => (
  <EmptyMessageContainer style={{ marginTop }}>
    <EmptyMessageTxt data-translation={message.key}>{message.txt}</EmptyMessageTxt>
    {buttonMessage && link && (
      <StyledLink to={link}>
        <SecondaryButton $buttonSize="large">
          <span>{buttonMessage.txt}</span>
        </SecondaryButton>
      </StyledLink>
    )}
  </EmptyMessageContainer>
);

export default EmptyListMessage;
